import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, vModelText as _vModelText, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/camera.svg'
import _imports_1 from '@/assets/cancel-small.svg'
import _imports_2 from '@/assets/error.svg'


const _withScopeId = n => (_pushScopeId("data-v-5f524932"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-page" }
const _hoisted_2 = { class: "top-container-wrapper" }
const _hoisted_3 = { class: "top-container" }
const _hoisted_4 = { class: "top-header" }
const _hoisted_5 = { class: "inner-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-switch has-text-centered" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1 /* HOISTED */))
const _hoisted_7 = { class: "upload-caption has-text-centered" }
const _hoisted_8 = { class: "has-text-weight-bold mb-0 text-sm" }
const _hoisted_9 = { class: "has-text-weight-bold m-0" }
const _hoisted_10 = { class: "cover-background" }
const _hoisted_11 = { class: "form-group mb-31" }
const _hoisted_12 = { class: "label-control has-text-weight-bold text-sm" }
const _hoisted_13 = { class: "username-wrap" }
const _hoisted_14 = { class: "form-group mb-31" }
const _hoisted_15 = { class: "label-control has-text-weight-bold text-sm" }
const _hoisted_16 = ["onMouseup"]
const _hoisted_17 = { class: "input-tag-entry" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "help" }
const _hoisted_20 = { class: "form-group mb-31" }
const _hoisted_21 = { class: "label-control has-text-weight-bold text-sm" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "label-control has-text-weight-bold text-sm" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "error-icon"
}, null, -1 /* HOISTED */))
const _hoisted_27 = { class: "web-link-border mt-4" }
const _hoisted_28 = { class: "web-links pb-3" }
const _hoisted_29 = { class: "web-link-content" }
const _hoisted_30 = { class: "web-link-label has-text-weight-semibold" }
const _hoisted_31 = { class: "web-link-link" }
const _hoisted_32 = { class: "web-link-cross has-text-right" }

import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { ref, computed, onMounted } from 'vue'
import { LinkMetadata } from '@lukso/lsp4-contracts'

import { InternalMethods } from '@/shared/apis/messages'
import { stripProtocol, formatTitle, truncateMiddle } from '@/shared/utils'
import Button from '@/popup/components/shared/Button.vue'
import ProfilePicture from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import RequestError from '@/popup/components/Modal/RequestError.vue'
import UploadingToIpfs from '@/popup/components/Modal/UploadingToIpfs.vue'
import ProfileBackground from '@/popup/components/shared/ProfileBackground/ProfileBackground.vue'
import IconButton from '@/popup/components/shared/IconButton.vue'
import { useAppStore } from '@/popup/store/AppStore'
import Scroll from '@/popup/components/shared/Scroll/Scroll.vue'
import { usernameValidator } from '@/popup/components/shared/Form/validators'
import { Input, Textarea, Error } from '@/popup/components/shared/Form/Form'
import { useUIStore } from '@/popup/store/UIStore'
import { PopupDatabase, saveLastState } from '@/popup/storage/Database'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { logError } from '@/shared/logger'
import { useNotifications } from '@/popup/compositions/useNotifications'
import { DBNotifications } from '@/shared/apis/bgnotifications'
import { ToastType } from '@/shared/models/AppNotification'
import { USERNAME_VALIDATOR } from '@/shared/regexValidator'
import { HTMLInputEvent } from '@/typings/html-input-events'
import { FrontendProfile } from '@/shared/models/Profile'
import { InputError } from '@/popup/components/shared/Form/FormTypes'
import { validateAndCompressImageFile, imageToBlob } from '@/shared/imageUtils'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import ModalTransition from '@/popup/components/shared/Modal/ModalTransition.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditProfile',
  setup(__props) {

const appStore = useAppStore()
const uiStore = useUIStore()
const router = useRouter()
const notifications = useNotifications()
const { getWeb3Eth } = useWeb3Eth()
const { t } = useI18n({ useScope: 'global' })

const usernameRef = ref<InstanceType<typeof Input>>()
const descriptionRef = ref<InstanceType<typeof Textarea>>()

const links = ref<LinkMetadata[]>([])
const username = ref('')
const usernameErrors = ref<InputError[]>([])
const description = ref('')
const tags = ref<string[]>([])
const newWebTitle = ref('')
const newWebLink = ref('')
const webLinkError = ref('')
const profilePictureError = ref<string>()
const profilePicture = ref<string | undefined>()
const profilePictureOrientation = ref<number>()
const profilePictureDirty = ref(false)
const coverPicture = ref<string | undefined>()
const coverPictureError = ref<string>()
const coverPictureOrientation = ref<number>()
const coverPictureDirty = ref(false)
const displayUploadingImages = ref(false)
const displayUploadingError = ref(false)

const newWebLinkRef = ref<HTMLInputElement | null>()
const newTagInputRef = ref<HTMLInputElement | null>()
const profilePictureRef = ref<HTMLInputElement | null>()
const coverPictureRef = ref<HTMLInputElement | null>()
const profile = ref(
  appStore.lastPopupState?.editProfile || appStore.currentProfile
)

onMounted(() => {
  // If the lastPopupState is from another profile, then ignore all edits.
  profile.value =
    appStore.lastPopupState?.editProfile &&
    appStore.lastPopupState?.editProfile.address ===
      appStore.currentProfile.address
      ? appStore.lastPopupState.editProfile
      : appStore.currentProfile
  description.value = profile.value.description || ''
  username.value = profile.value.name || ''
  links.value = profile.value.links || []
  tags.value = profile.value.tags || []
  profilePicture.value = profile.value.profilePicture
  profilePictureOrientation.value = profile.value.profilePictureOrientation
  coverPicture.value = profile.value.coverPicture
  coverPictureOrientation.value = profile.value.coverPictureOrientation
  profilePictureDirty.value = !!profile.value.profilePictureDirty
  coverPictureDirty.value = !!profile.value.coverPictureDirty
})

const handleChangeProfilePicture = async (event: Event) => {
  try {
    const files = (event as HTMLInputEvent).target.files
    if (files !== null) {
      const { file, orientation } = await validateAndCompressImageFile(files[0])
      profilePictureOrientation.value = orientation
      const response = await imageToBlob(file)
      profilePicture.value = response
      profilePictureDirty.value = true
      saveState()
    }
  } catch (error) {
    logError(`Error while changing profile picture:`, error)
    profilePictureError.value = t('edit_profile.invalid_image')
  }
}

const handleChangeCoverPicture = async (event: Event) => {
  try {
    const files = (event as HTMLInputEvent).target.files
    if (files !== null) {
      const { file, orientation } = await validateAndCompressImageFile(files[0])
      profilePictureOrientation.value = orientation
      const response = await imageToBlob(file)
      coverPicture.value = response
      coverPictureDirty.value = true
      saveState()
    }
  } catch (error) {
    logError(`Error while changing cover picture:`, error)
    coverPictureError.value = t('edit_profile.invalid_image')
  }
}

const onCancel = async () => {
  await saveLastState({
    path: '/home',
    editProfile: undefined,
  })
  ;(uiStore.isFirefox || uiStore.isLinuxOs) && uiStore.isPopup
    ? window.close()
    : router.push('/home')
}

const uploadToIpfs = async (currentProfile: FrontendProfile): Promise<void> => {
  try {
    displayUploadingImages.value = true
    const profileToSave = JSON.parse(JSON.stringify(currentProfile))
    appStore.setTemporaryProfile(profileToSave)

    const { data } = await useGlobals().sendMessage({
      method: InternalMethods.UPLOAD_TO_IPFS,
      payload: profileToSave,
    })

    getWeb3Eth()
      .sendTransaction({
        from: appStore.currentProfile.address,
        to: appStore.currentProfile.address,
        data,
      })
      .on('error', error => {
        const message = error?.message ?? t('app_detail.save_error')
        notifications.updateToast({
          id: appStore.currentProfile.address,
          message,
          profileAddress: appStore.currentProfile.address,
          method: DBNotifications.NOTIFICATION,
          system: false,
          type: ToastType.ERROR,
          isPersistent: false,
        })
      })
  } catch (error) {
    logError(`Error while uploading to ipfs:`, error)
    displayUploadingImages.value = false
    displayUploadingError.value = true
  }
}

const isProfileTheSame = (
  currentProfile: FrontendProfile,
  profileToSave?: FrontendProfile
): boolean => {
  return (
    !profileToSave ||
    (currentProfile.profilePictureDirty === profileToSave.profilePictureDirty &&
      currentProfile.coverPictureDirty === profileToSave.coverPictureDirty &&
      currentProfile.name === profileToSave.name &&
      JSON.stringify(currentProfile.tags) ===
        JSON.stringify(profileToSave.tags) &&
      currentProfile.description === profileToSave.description &&
      JSON.stringify(currentProfile.links) ===
        JSON.stringify(profileToSave.links))
  )
}

const validate = () => {
  usernameRef.value?.validate(username.value)
  descriptionRef.value?.validate(description.value)
}

const handleSave = async () => {
  validate()
  if (!isValidProfile.value) {
    return notifications.updateToast({
      id: appStore.currentProfile.address,
      message: t('edit_profile.invalid_profile'),
      profileAddress: appStore.currentProfile.address,
      method: DBNotifications.NOTIFICATION,
      system: false,
      type: ToastType.ERROR,
      isPersistent: false,
    })
  }

  if (newWebLink.value.length > 0) addWebLink()

  const { saved: oldProfile = { address: appStore.currentProfile.address } } =
    (await PopupDatabase.getPopupProfile(appStore.currentProfile.address)) || {}

  const currentState: FrontendProfile = {
    ...oldProfile,
    address: appStore.currentProfile.address,
    verification: appStore.currentProfile.verification,
    profileImage: appStore.currentProfile.profileImage,
    backgroundImage: appStore.currentProfile.backgroundImage,
    description: description.value,
    name: username.value,
    tags: tags.value,
    links: links.value,
    coverPicture: coverPicture.value,
    coverPictureDirty: coverPictureDirty.value,
    coverPictureOrientation: coverPictureOrientation.value,
    profilePictureOrientation: profilePictureOrientation.value,
    profilePicture: profilePicture.value,
    profilePictureDirty: profilePictureDirty.value,
  }

  if (!isProfileTheSame(oldProfile, currentState)) {
    await saveState()
    await uploadToIpfs(currentState)
  }
}

const handleSaveTag = async (event: KeyboardEvent | FocusEvent) => {
  event.preventDefault()
  const newTag = newTagInputRef.value?.value?.trim()
  if (newTag && newTag.length > 0 && !tags.value.includes(newTag)) {
    tags.value.push(newTag)
  }
  ;(newTagInputRef.value as HTMLInputElement).value = ''
  await saveState()
}

const handleDeleteTag = (name: string) => {
  tags.value = tags.value.filter(_name => _name !== name)
}

const checkWebLink = (event: HTMLInputEvent | KeyboardEvent) => {
  const title = newWebTitle.value
  const url = newWebLink.value
  const newTitle = stripProtocol(url)
  if (title.length === 0 && event.key === '.' && newTitle !== 'www') {
    newWebTitle.value = formatTitle(newTitle)
  }
}

const onPasteWebLink = (event: ClipboardEvent) => {
  const title = newWebTitle.value
  const url = event.clipboardData?.getData('text/plain') || ''
  const newTitle = stripProtocol(url)
  if (title.length === 0) {
    newWebTitle.value = formatTitle(newTitle)
  }
}

const addWebLink = async () => {
  const title = newWebTitle.value
  let url = newWebLink.value

  if (url.length === 0) {
    webLinkError.value = t('create_profile.web_link.error')
    return
  }

  if (!url.includes('://')) {
    url = `https://${url}`
  }

  webLinkError.value = ''
  links.value.push({
    title,
    url,
  })
  newWebLink.value = ''
  newWebTitle.value = ''
  newWebLinkRef.value?.focus()
  await saveState()
}

const saveState = async () => {
  const editProfile: FrontendProfile = {
    address: appStore.currentProfile.address,
    verification: appStore.currentProfile.verification,
    profileImage: appStore.currentProfile.profileImage,
    backgroundImage: appStore.currentProfile.backgroundImage,
    name: username.value,
    description: description.value,
    tags: tags.value,
    links: links.value,
    coverPicture: coverPicture.value,
    coverPictureDirty: coverPictureDirty.value,
    coverPictureOrientation: coverPictureOrientation.value,
    profilePicture: profilePicture.value,
    profilePictureOrientation: profilePictureOrientation.value,
    profilePictureDirty: profilePictureDirty.value,
  }

  await saveLastState({
    path: router.currentRoute.value.path,
    editProfile: JSON.parse(JSON.stringify(editProfile)),
  })
}

const handleDeleteWebLink = (index: number) => links.value.splice(index, 1)

const addressLeft = computed(() => {
  const charWidth = 8.4
  const padding = 20
  const usernameLength = username.value?.length

  return (
    (usernameLength <= 30 ? usernameLength : 30) * charWidth +
    padding
  ).toString()
})

const isValidProfile = computed(() => {
  return usernameErrors.value?.length === 0
})

const getWebReferenceTitle = () =>
  links.value.map(link =>
    link.title.length > 0 ? link.title : stripProtocol(link.url)
  )

const onKeyPress = (event: KeyboardEvent) => {
  if (USERNAME_VALIDATOR.test(event.key)) {
    event.preventDefault()
    usernameErrors.value = [t('create_profile.user_name.hint')]
    return
  }
  usernameErrors.value = []
}

const onUsernameErrors = (newErrors: InputError[]) =>
  (usernameErrors.value = newErrors)

const onUsernameUpdate = (newValue: string) =>
  (username.value = newValue.toLowerCase())

const onDescriptionUpdate = (newValue: string) => (description.value = newValue)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("lukso-button", {
            class: "top-button-cancel",
            "custom-class": "paragraph-inter-14-semi-bold h-[48px]",
            variant: "text",
            onClick: onCancel
          }, _toDisplayString(_ctx.$t('create_profile.button.cancel')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('create_profile.title.edit_profile')), 1 /* TEXT */),
          _createElementVNode("lukso-button", {
            "custom-class": "paragraph-inter-14-semi-bold h-[48px]",
            class: "top-button-save",
            variant: "text",
            onClick: handleSave
          }, _toDisplayString(_ctx.$t('create_profile.button.save')), 1 /* TEXT */)
        ])
      ]),
      _createVNode(Scroll, {
        class: _normalizeClass(`content content-profile ${_unref(uiStore).toast && 'custom-height'}`),
        "hidden-tracks": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ProfilePicture, {
              class: "profile-upload",
              "frontend-profile": profile.value,
              "with-identicon": false,
              size: "large",
              "img-url": profilePicture.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (profilePictureRef.value?.click()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["frontend-profile", "img-url"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('create_profile.profile.add_photo')), 1 /* TEXT */),
              _createVNode(_unref(Error), {
                error: profilePictureError.value,
                "is-centered": true
              }, null, 8 /* PROPS */, ["error"])
            ]),
            _createElementVNode("input", {
              ref_key: "profilePictureRef",
              ref: profilePictureRef,
              hidden: "",
              type: "file",
              onChange: handleChangeProfilePicture
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
            _createElementVNode("input", {
              ref_key: "coverPictureRef",
              ref: coverPictureRef,
              hidden: "",
              type: "file",
              onChange: handleChangeCoverPicture
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
            _createElementVNode("div", {
              class: "cover-content is-flex is-align-items-center is-justify-content-center is-flex-direction-column",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (coverPictureRef.value?.click()))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`cover-foreground
          ${coverPicture.value ? 'create-cover' : ''}
          `)
              }, [
                _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.$t(`create_profile.cover.${coverPicture.value ? 'change' : 'add'}`)), 1 /* TEXT */)
              ], 2 /* CLASS */),
              _withDirectives(_createElementVNode("div", _hoisted_10, [
                _createVNode(ProfileBackground, {
                  "profile-background": coverPicture.value,
                  height: 192,
                  width: 328
                }, null, 8 /* PROPS */, ["profile-background"])
              ], 512 /* NEED_PATCH */), [
                [_vShow, coverPicture.value]
              ]),
              _createVNode(_unref(Error), {
                error: coverPictureError.value,
                "is-centered": true
              }, null, 8 /* PROPS */, ["error"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('create_profile.user_name.label')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(Input), {
                  name: "username",
                  ref_key: "usernameRef",
                  ref: usernameRef,
                  value: username.value,
                  placeholder: _ctx.$t('create_profile.user_name.placeholder'),
                  errors: usernameErrors.value,
                  validators: [_unref(usernameValidator)],
                  "data-testid": "username",
                  "extra-classes": "input",
                  onOnBlur: saveState,
                  onOnUpdate: onUsernameUpdate,
                  onOnErrors: onUsernameErrors,
                  onOnKeyPress: onKeyPress
                }, null, 8 /* PROPS */, ["value", "placeholder", "errors", "validators"]),
                _createElementVNode("span", {
                  class: "first-four is-family-monospace",
                  style: _normalizeStyle({ left: addressLeft.value + 'px' })
                }, _toDisplayString(username.value?.length
                  ? `#${_unref(appStore).currentProfile?.address?.slice(2, 6)}`
                  : null), 5 /* TEXT, STYLE */)
              ]),
              _createVNode(_unref(Error), {
                error: usernameErrors.value[0]
              }, null, 8 /* PROPS */, ["error"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('create_profile.tags.label')), 1 /* TEXT */),
              _createElementVNode("div", {
                class: "input-tag-wrapper",
                tabindex: "1",
                onMouseup: _cache[2] || (_cache[2] = ($event: any) => (newTagInputRef.value?.focus()))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag,
                    class: "input-tag"
                  }, [
                    _createTextVNode(_toDisplayString(tag) + " ", 1 /* TEXT */),
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "tag-close-icon",
                      onMouseup: () => handleDeleteTag(tag)
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_16)
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("input", {
                    ref_key: "newTagInputRef",
                    ref: newTagInputRef,
                    maxlength: "20",
                    disabled: tags.value.length >= 3,
                    class: _normalizeClass(`input-tag-input ${tags.value.length === 0 && 'no-tags'}`),
                    onBlur: handleSaveTag,
                    onKeypress: [
                      _withKeys(handleSaveTag, ["enter"]),
                      _withKeys(handleSaveTag, [","]),
                      _withKeys(handleSaveTag, ["tab"])
                    ]
                  }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_18)
                ])
              ], 32 /* NEED_HYDRATION */),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('create_profile.tags.help')), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('create_profile.bio.label')), 1 /* TEXT */),
              _createVNode(_unref(Textarea), {
                name: "description",
                ref_key: "descriptionRef",
                ref: descriptionRef,
                maxlength: 200,
                value: description.value,
                placeholder: _ctx.$t('create_profile.bio.placeholder'),
                "has-counter": true,
                "has-autogrow": true,
                onOnBlur: saveState,
                onOnUpdate: onDescriptionUpdate
              }, null, 8 /* PROPS */, ["value", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('create_profile.references.link_label')), 1 /* TEXT */),
              _withDirectives(_createElementVNode("input", {
                ref_key: "newWebLinkRef",
                ref: newWebLinkRef,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newWebLink).value = $event)),
                class: "form-control input-outline mb-9",
                placeholder: _ctx.$t('create_profile.references.link_placeholder'),
                onKeypress: [
                  checkWebLink,
                  _withKeys(addWebLink, ["enter"])
                ],
                onPaste: onPasteWebLink
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_24), [
                [_vModelText, newWebLink.value]
              ]),
              _withDirectives(_createElementVNode("input", {
                ref: "newWebTitleRef",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newWebTitle).value = $event)),
                class: "form-control input-outline",
                placeholder: _ctx.$t('create_profile.references.title_placeholder'),
                onKeypress: _withKeys(addWebLink, ["enter"])
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_25), [
                [_vModelText, newWebTitle.value]
              ]),
              _withDirectives(_createElementVNode("p", {
                class: _normalizeClass(`help is-align-items-center ${
              webLinkError.value.length > 0 && 'is-flex'
            }`)
              }, [
                _hoisted_26,
                _createTextVNode(" " + _toDisplayString(webLinkError.value), 1 /* TEXT */)
              ], 2 /* CLASS */), [
                [_vShow, webLinkError.value.length > 0]
              ])
            ]),
            _createVNode(Button, {
              variant: "text",
              "is-full-width": true,
              class: _normalizeClass(`mt-2 ${newWebTitle.value && newWebLink.value && 'active'}`),
              onClick: addWebLink
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('create_profile.references.button')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["class"]),
            _withDirectives(_createElementVNode("div", _hoisted_27, null, 512 /* NEED_PATCH */), [
              [_vShow, links.value?.length > 0]
            ]),
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, ({ title, url }, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: title,
                  class: "web-link web-link-border is-flex"
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(truncateMiddle)(getWebReferenceTitle()[index], 25, 6)), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_31, _toDisplayString(url), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(IconButton, {
                      onOnClick: ($event: any) => (handleDeleteWebLink(index))
                    }, null, 8 /* PROPS */, ["onOnClick"])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(ModalTransition, null, {
        default: _withCtx(() => [
          (displayUploadingImages.value)
            ? (_openBlock(), _createBlock(UploadingToIpfs, { key: 0 }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(ModalTransition, null, {
        default: _withCtx(() => [
          (displayUploadingError.value)
            ? (_openBlock(), _createBlock(RequestError, {
                key: 0,
                onOnConfirm: _cache[5] || (_cache[5] = ($event: any) => (displayUploadingError.value = false))
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})